import React from "react";

import { Avatar, Box, Drawer, Stack } from "@mui/material";
import { CryptoIcon } from "assets/material-custom-icons";
// import CheckIcon from "@mui/icons-material/Check";

import { SimpleHeadMui } from "components/Simple-head/SimpleHeadMui";
import { useCryptoCurrencyDrawerSelect, useDealCryptocurrencyIconSelect, useViewActions } from "store";

import { Main } from "./Main";

export const Cryptocurrency: React.FC = () => {
  const { setCryptoCurrencyStateAction } = useViewActions();

  const iconUrl = useDealCryptocurrencyIconSelect();

  const isDrawerOpen = useCryptoCurrencyDrawerSelect();

  const onClose = () => {
    setCryptoCurrencyStateAction(false);
  };

  return (
    <>
      <Box sx={{ position: "relative" }} onClick={() => setCryptoCurrencyStateAction(true)}>
        {iconUrl ? (
          <Avatar sx={{ width: "30px", height: "30px", cursor: "pointer" }} variant="square" src={iconUrl} />
        ) : (
          <CryptoIcon sx={{ height: "30px", width: "30px", cursor: "pointer" }} />
        )}
      </Box>
      <Drawer
        sx={{
          ".MuiPaper-root": {
            borderTopRightRadius: "25px",
            borderBottomRightRadius: "25px"
          }
        }}
        open={isDrawerOpen}
        onClose={onClose}
      >
        <Stack alignItems="stretch" height="100%" maxWidth="519px" minWidth="519px" bgcolor="#ffffff" overflow="hidden">
          <SimpleHeadMui onIconClick={onClose}>Cryptocurrency Connection</SimpleHeadMui>
          <Main cryptoIcon={iconUrl} onClose={onClose} />
        </Stack>
      </Drawer>
    </>
  );
};
